import SqShopFooter from '@square/sq-shop-footer/dist/sq-shop-footer.esm';
import { canUseDashboardMode } from 'utilities/dashboard_mode';
import { isDashboardMode } from 'helpers/search_parameter_helpers';

window.Sq = window.Sq || {};

const initSqShopFooter = () => {
  const el = document.getElementById('sq-shop-footer');
  if (el === null) {
    return;
  }

  if (canUseDashboardMode(window.location.pathname) && isDashboardMode()) {
    el.style.display = 'none';
  }

  Sq.SqShopFooter = new SqShopFooter({
    target: el,
    props: JSON.parse(el.dataset.footerProps),
  });
};

document.addEventListener('DOMContentLoaded', initSqShopFooter);
